.multi-select {
  border: 1px solid var(--color-uva-black);
  border-radius: var(--border-radius-default);
  padding: 0.75rem;
}

.multi-select--no-border {
  border: none;
  padding: 0;
}

.multi-select__header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.multi-select__list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  list-style: none;
  margin: 0;
  padding: 0;
}

.multi-select__list--scrollable {
  max-height: 8.75rem;
  overflow: auto;
}

.multi-select__item {
  align-items: start;
  display: grid;
  grid-template-columns: auto 1fr;
  user-select: none;
}

.multi-select__item input[type="checkbox"] {
  margin-right: 0.75rem;
  margin-top: 0.25rem;
}

.multi-select__item input[type="checkbox"]:disabled + label {
  color: var(--color-grey-500);
}
